import dayjs from "dayjs";

export const poRecvColumns = [
  {
    field: "lineNo",
    headerName: "Line No",
    align: "right",
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    // sortable: false,
    left: 180,
    border: true,
    width: 200
  },
  {
    field: "packType",
    headerName: "Pack Type",
    // sortable: false,
    width: 100,
    align: "left",
  },
  {
    field: "baseUOM",
    headerName: "Base UOM",
    sortable: false,
    width: 100,
    align: "left",
  },
  {
    field: "cartonID",
    headerName: "Carton ID",
    width: 120,
    align: "left",
  },
  {
    field: "vDONo",
    headerName: "Do No",
    width: 220,
    align: "left",
  },
  {
    field: "vInvNo",
    headerName: "Inv No",
    width: 220,
    align: "left",
  },
  {
    field: "mln",
    headerName: "MLN",
    width: 120,
    align: "left",
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    width: 120,
    align: "left",
    valuesGetter: (col) => {
      return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
    },
  },
  {
    field: "qtyExpected",
    headerName: "Qty Expected",
    width: 120,
    align: "right",
  },
  {
    field: "qtyReceived",
    headerName: "Qty Received",
    width: 120,
    align: "right",
  },
  {
    field: "uom",
    headerName: "UOM",
    width: 80,
    // valueGetter: (col) => {
    //   return col?.value?.label ?? "";
    // },
    valuesGetter: (col) => {
      return col.label
    }
  },
  {
    field: "quantity",
    headerName: "Quantity",
    width: 100,
    align: "right",
  },
  {
    field: "manufacturingDate",
    headerName: "MFG Date",
    width: 120,
    align: "left",
    valuesGetter: (col) => {
      return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
    },
  },
  {
    field: "recvLocation",
    headerName: "Recv Location",
    width: 150,
    align: "left",
  },
  {
    field: "serialNumbers",
    headerName: "Serial Numbers Count",
    width: 120,
    align: "right",
    valuesGetter: (col) => {
      return Boolean(col) ? col.length : 0;
    },
  },
]

export const poRecvViewColumns = [
  {
    field: "lineNo",
    headerName: "Line No",
    align: "right",
    left: 0,
    width: 100
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    left: 100,
    width: 200,
    border: true
  },
  {
    field: "packType",
    headerName: "Pack Type",
    // sortable: false,
    width: 100,
    align: "left",
  },
  {
    field: "baseUOM",
    headerName: "Base UOM",
    sortable: false,
    width: 100,
    align: "left",
  },
  {
    field: "cartonID",
    headerName: "Carton ID",
    width: 120,
    align: "left",
  },
  {
    field: "vDONo",
    headerName: "Do No",
    width: 220,
    align: "left",
  },
  {
    field: "vInvNo",
    headerName: "Inv No",
    width: 220,
    align: "left",
  },
  {
    field: "mln",
    headerName: "MLN",
    width: 120,
    align: "left",
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    width: 120,
    align: "left",
  },
  {
    field: "qtyExpected",
    headerName: "Qty Expected",
    width: 120,
    align: "right",
  },
  {
    field: "qtyReceived",
    headerName: "Qty Received",
    width: 120,
    align: "right",
  },
  {
    field: "uom",
    headerName: "UOM",
    width: 80,
    // valueGetter: (col) => {
    //   return col?.value?.label ?? "";
    // },
    valuesGetter: (col) => {
      return col.label
    }
  },
  {
    field: "quantity",
    headerName: "Quantity",
    width: 100,
    align: "right",
  },
  {
    field: "manufacturingDate",
    headerName: "MFG Date",
    width: 120,
    align: "left",
  },
  {
    field: "recvLocation",
    headerName: "Recv Location",
    width: 150,
    align: "left",
  },
]